// ============================================================================
// UKKONEN ALGORITHM - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'ukkonen-algorithm',
  name: 'Ukkonen Algorithm',
  category: 'Strings',
  complexity: {
    time: 'O(N)',
    space: 'O(N)'
  },
  description: 'An online linear-time algorithm for constructing suffix trees. It builds the tree incrementally by adding characters one at a time, using suffix links and active points to maintain efficiency.'
};
